import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { Review, REVIEW_COMPANY_STATUS } from 'voxloud-types/dist/models/reviews';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { ReviewDetailsPopupComponent } from '../review-details-popup/review-details-popup.component';
import { UpdateReviewPopupComponent } from '../update-review-popup/update-review-popup.component';

@Component({
  selector: 'gdp-reviews-table',
  templateUrl: './reviews-table.component.html',
  styleUrls: ['./reviews-table.component.scss']
})
export class ReviewsTableComponent implements OnInit {
  @Input() loading: boolean;
  @Input() reviews: Review[];
  @Input() loadingLinesArray: number;
  @Output() onUpdateReviews: EventEmitter<any> = new EventEmitter();
  public locale: string;
  public reviewCompanyStatus = REVIEW_COMPANY_STATUS;
  constructor(
    private notification: NotificationService,
    private modalService: NgbModal,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.locale = `${this.translate.currentLang}-${this.translate.currentLang.toUpperCase()}`;
    this.translate.onLangChange.subscribe((l: LangChangeEvent) => {
      this.locale = `${l.lang}-${l.lang.toUpperCase()}`;
    });
  }

  openDetailsReviewPopup(review: Review) {
    const modal = this.modalService.open(ReviewDetailsPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.review = review;
  }

  openUpdateReviewPopup(review: Review) {
    const modal = this.modalService.open(UpdateReviewPopupComponent, {
      size: 'md'
    });
    modal.componentInstance.review = review;

    modal.componentInstance.onAssigntoCompany.pipe(take(1)).subscribe(() => {
      this.onUpdateReviews.emit();
      this.notification.success('reviews.notifications.success.updated');
    })
  }

}
